<div class="grid grid-cols-1 gap-6 lg:grid-cols-12">
  <div class="lg:col-span-4">
    <clp-course-module-lesson-list (lessonEditEvent)="populqteLessonForm($event)" [courseId]="courseId"></clp-course-module-lesson-list>
  </div>
  <div class="lg:col-span-8">

    <form class="space-y-4" (ngSubmit)="editLesson(lessonForm.value)" [formGroup]="lessonForm" novalidate>
      <input type="hidden" formControlName="id">

      <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
        <div class="md:col-span-5">
          <label for="moduleId" class="clp-label">{{'lesson.create.module' | translate}}</label>
          <select class="clp-select" id="moduleId" formControlName="moduleId" required>
            <option>---</option>
            @for (module of courseModules$ | async; track module) {
              <option [value]="module.id">{{ module.title }}</option>
            }
          </select>
          @if (lessonForm.controls['moduleId'].invalid && lessonForm.controls['moduleId'].touched) {
            <div class="clp-help">
              {{'lesson.create.invalidModule' | translate}}
            </div>
          }
        </div>

        <div class="md:col-span-3">
          <label for="status" class="clp-label">{{'course.create.status' | translate}}</label>
          <select class="clp-select" id="status" formControlName="status" required>
            @for (status of statuses; track status) {
              <option [value]="status.value">{{ status.label | translate }}</option>
            }
          </select>
          @if (lessonForm.controls['status'].invalid && lessonForm.controls['status'].touched) {
            <div class="clp-help">
              {{'course.create.invalidStatus' | translate}}
            </div>
          }
        </div>
      </div>

      <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
        <div class="md:col-span-10">
          <label for="title" class="clp-label">{{'lesson.create.name' | translate}}</label>
          <input type="text" class="clp-input" id="title" formControlName="title" required>
          @if (lessonForm.controls['title'].invalid && lessonForm.controls['title'].touched) {
            <div class="clp-help">
              {{'lesson.create.invalidTitle' | translate}}
            </div>
          }
        </div>

        <div class="md:col-span-2">
          <label for="order" class="clp-label">{{'lesson.create.order' | translate}}</label>
          <input type="number" class="clp-input" id="order" formControlName="order" min="1" required>
          @if (lessonForm.controls['order'].invalid && lessonForm.controls['order'].touched) {
            <div class="clp-help">
              {{'lesson.create.invalidOrder' | translate}}
            </div>
          }
        </div>
      </div>

      <div>
        <label for="description" class="clp-label">{{'lesson.create.description' | translate}}</label>
        <textarea type="text" class="clp-textarea" id="description" formControlName="description" required></textarea>
        @if (lessonForm.controls['description'].invalid && lessonForm.controls['description'].touched) {
          <div class="clp-help">
            {{'lesson.create.invalidDescription' | translate}}
          </div>
        }
      </div>

      <div class="grid grid-cols-1 gap-4 md:grid-cols-12">
        <div class="md:col-span-3">
          <label class="clp-label">{{'lesson.create.videoType' | translate}}</label>
          <select class="clp-select" formControlName="videoType" id="videoType">
            <option value="1">YouTube</option>
            <option value="2">Vimeo</option>
          </select>
        </div>

        <div class="md:col-span-6">
          <label class="clp-label">{{'lesson.create.videoLink' | translate}}</label>
          <input class="clp-input" data-testId="videoLink"
            placeholder="Ex: GgXI1anQ5C4"
            formControlName="videoLink" id="videoLink" />
        </div>
      </div>

      @if (lessonForm.errors?.['videoFieldsRequired'] && lessonForm.touched) {
        <div class="clp-help">
          {{ 'lesson.upsert.videoFieldsRequiredErrorMessage' | translate }}
        </div>
      }

      <div class="flex justify-end">
        <button type="submit" class="clp-btn clp-btn-warning">{{'general.save' | translate}}</button>
      </div>
    </form>
  </div>
</div>
